import React from 'react';
import './About.css'; 

function About() {
  return (
    <section className="aboutUS">
      <div className="aboutUS-text">
        <h2>About Us</h2>
        <p>
        Welcome to Glorious Fabric Pvt Ltd ! Located in the heart of Malwana , we are a premier fabric store dedicated to
        offering high-quality textiles at competitive prices. Our journey began in 2020 when we first stepped into the fabric
        industry. Over the years, we have steadily grown and refined our expertise, culminating in the official launch of our
        large-scale business on February 12, 2024.As a partnership venture, Glorious Fabric specializes in directly importing
        premium fabrics from around the globe. We cater to both wholesale and retail customers, ensuring that top-notch
        materials are accessible to everyone at affordable prices .Our mission is simple: to provide a diverse range of fabrics that
        meet your needs and exceed your expectations. Whether you are a designer, retailer, or individual buyer, we are here to
        support your projects with our exceptional service and competitive pricing. Thank you for choosing Glorious Fabric Pvt
        Ltd. 
        </p>
      </div>
      <img src="/Home/AboutPIC.png" alt="Fabric" />
    </section>
  );
}

export default About;
